<template>
    <div id="chat-room">
        <transition name="slide-fade">
            <div v-show="its_open" class="chat mb-3">
                <b-embed
                    type="iframe"
                    aspect="1by1"
                    src="https://www6.cbox.ws/box/?boxid=863206&boxtag=MhCsk3"
                ></b-embed>
            </div>
        </transition>
        <transition name="slide-fade">
        <div v-show="!its_open" class="chat-icon bg-transparent">
            <b-icon icon="chat-square-text-fill" variant="info" class="p-0 mr-3 mb-3" font-scale="2.5" @click="its_open = !its_open"></b-icon>
        </div>
        </transition>
    </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
    name: 'ChatRoom',
    props: {
        title: { type: String, default: "Sala pública" },
        subTitle: { type: String, default: "Chat..." },
    },
    data() {
        return {
            its_open: true,
        }
    },
    methods: {
        close() {
            if(this.sent_by) this.$emit('closed')
            else this.its_open = !this.its_open
        },
    },
    created () {
    },
})
</script>

<style lang="scss" scoped >
    $chat-width: 100%;
    $chat_height: 100%;
    $border-radius : 10px;

    #chat-room {
        height: 100%;
        width: 100%;
    }

    .embed-responsive-1by1 {
        height: $chat_height;
        margin: 0px !important;
        padding: 2px;
        color: var(--secondary);
        background-color: var(--dark);
        margin: 0px 10px 10px 0px;
        border-radius: 10px;
        border: solid 3px var(--dark);
        box-shadow: 2px 2px 5px 2px rgba(0, 0, 0, 0.3)
    }

    .slide-fade-enter-active {
        transition: all .3s ease;
    }
    .slide-fade-leave-active {
        transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter, .slide-fade-leave-to {
        transform: translateX(10px);
        opacity: .5;
    }

    .chat-icon {
        position: fixed;
        left:20px;
        bottom: 0px;
        color:#ffffff;
        margin: 0px 10px 10px 0px;
    }

    .chat {
        width: $chat-width;
        height: $chat_height;
        position: relative;
        bottom: 0px;
        color:#ffffff;
        margin: 0px 0px 0px 0px;
    }

    header {
        height: 58px;
        padding: 10px;
        width: $chat-width*.99;
        display: flex;
        flex-direction: row;
        border-top-left-radius: $border-radius;
        border-top-right-radius: $border-radius;

        img.logo {
            height: 40px !important;
            margin-left:-7px !important;
        }

        h3 {
            font-size: 1.02rem !important;
            line-height: 1rem !important;

            small {
                font-size: .7rem !important;
            }
        }
    }
</style>